import React from "react";
import Button from "./Button";
import useDarkMode from "../hooks/useDarkMode";
import { useFormCtx } from "./../FormContext";
import * as Const from "./../_Const";
import useScreenType from "../hooks/useScreenType";

const DebugPage = ({ terminal, uid, keyNumber }) => {
  const {
    handleDebug,
    navigateToServicePage,
    handleAnimationDisabled,
    isAnimationDisabled,
    setDarkMode,
    runRestartOrShutdown,
    isSoundEnabled,
    setSoundEnabledApi,
    isPhotoCaptureTestEnabled,
    setPhotoCaptureTestEnabledApi,
    isWithoutCardEnabled,
    setWithouCardApi,
    eraseTerminalLog,
  } = useFormCtx();
  const screenType = useScreenType();
  const [isDarkMode, toggleTheme] = useDarkMode();
  const textAnimation = isAnimationDisabled ? "Animace - Zapnout" : "Animace - Vypnout";
  const textSound = isSoundEnabled ? "Zvuk - Vypnout" : "Zvuk - Zapnout";
  const textDarkLightMode = isDarkMode ? "Nastavit Světlý řežim" : "Nastavit Tmavý řežim";
  const textCameraTest = isPhotoCaptureTestEnabled ? "Kamera Test - Vypnout" : "Kamera Test - Zapnout";
  const textPatWithoutCard = isWithoutCardEnabled ? "Pac. bez průkazu - Vypnout" : "Pac. bez průkazu - Zapnout";

  function handleDarkMode() {
    setDarkMode(!isDarkMode);
    toggleTheme();
  }

  function closeDebug() {
    window.location.reload();
  }

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "info-data":
          css = "mt-0 mx-2 text-md";
          break;
        case "row":
          css = "mt-2 gap-2 mx-2";
          break;
        case "bottom-row":
          css = "gap-2 left-6 right-6";
          break;
        case "btn":
          css = "h-16 text-xs";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "info-data":
          css = "mt-2 mx-6 text-2xl";
          break;
        case "row":
          css = "mt-6 gap-4 mx-4";
          break;
        case "bottom-row":
          css = "gap-4 left-4 right-4";
          break;
        case "btn":
          css = "h-20";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "info-data":
          css = "mt-2 mx-6 text-2xl";
          break;
        case "row":
          css = "mt-6 gap-4 mx-4";
          break;
        case "bottom-row":
          css = "gap-4 left-4 right-4";
          break;
        case "btn":
          css = "h-20";
          break;
      }
    }

    return css;
  }

  return (
    <>
      <div className={`${getCssFor("info-data")} dark:text-accent text-accent-dark`}>{/* Klíč: {keyNumber} - Terminal: {terminal} - Mobile UID: {uid} */}</div>
      <div className={`${getCssFor("row")} grid grid-cols-4 `}>
        <Button title="HW SW info" showIcon={false} className={`${getCssFor("btn")}`} onClick={() => navigateToServicePage(Const.PAGE_HW_SW_INFO)} />
        <Button title="Log terminálu" showIcon={false} className={`${getCssFor("btn")}`} onClick={() => navigateToServicePage(Const.PAGE_ERROR_LOG_TERMINAL)} />
        <Button title="Log web aplikace" showIcon={false} className={`${getCssFor("btn")}`} onClick={() => navigateToServicePage(Const.PAGE_ERROR_LOG)} />

        <Button title="Nastavení kamery" showIcon={false} className={`${getCssFor("btn")}`} onClick={() => navigateToServicePage(Const.PAGE_CAMERA_TEST)} />

        {/* <Button title="Test Page" showIcon={false} className={`${getCssFor("btn")}`} onClick={() => navigateToServicePage(Const.PAGE_TEST)} /> */}
      </div>
      <div className={`${getCssFor("row")} grid grid-cols-4 `}>
        <Button
          title={textCameraTest}
          showIcon={false}
          className={`${getCssFor("btn")}`}
          onClick={async () => await setPhotoCaptureTestEnabledApi(!isPhotoCaptureTestEnabled)}
        />
        <Button title={textSound} showIcon={false} className={`${getCssFor("btn")}`} onClick={async () => await setSoundEnabledApi(!isSoundEnabled)} />
        <Button title={textDarkLightMode} showIcon={false} className={`${getCssFor("btn")}`} onClick={handleDarkMode} />
        <Button
          title={textPatWithoutCard}
          showIcon={false}
          className={`${getCssFor("btn")}`}
          onClick={async () => await setWithouCardApi(!isWithoutCardEnabled)}
        />
      </div>
      <div className={`${getCssFor("row")} grid grid-cols-4 `}>
        <Button title={textAnimation} showIcon={false} className={`${getCssFor("btn")}`} onClick={() => handleAnimationDisabled(!isAnimationDisabled)} />
      </div>

      <div className={`${getCssFor("bottom-row")} grid grid-cols-4 absolute bottom-8`}>
        <Button
          title="Vypnout"
          showIcon={false}
          type="clickonce-red"
          className={`${getCssFor("btn")}`}
          onClick={() => runRestartOrShutdown(Const.OPERATION_SHUTDOWN)}
        />
        <Button
          title="Restart"
          showIcon={false}
          type="clickonce-red"
          className={`${getCssFor("btn")}`}
          onClick={() => runRestartOrShutdown(Const.OPERATION_RESTART)}
        />
        <div className=""></div>
        <Button title="Ukončit DEBUG Mode" type="error-dark" className={`${getCssFor("btn")}`} showIcon={false} onClick={() => closeDebug()} />
      </div>
    </>
  );
};

export default DebugPage;
